import { IApplicationDto } from "./ApplicationDto";

export interface IApplicationsDto {
  Apps: IApplicationDto[] | null;
  totalNumApps: number | null;
}

export class ApplicationsDto implements IApplicationsDto {
  public Apps: IApplicationDto[];
  public totalNumApps: number | null;

  constructor(applications: Array<IApplicationDto> = new Array<IApplicationDto>(), totalNumApps: number | null) {
    this.Apps = applications;
    this.totalNumApps = totalNumApps;
  }
}